<template>
	<div class="pb-7 mb-7">


		<PayoutOptionDenominationsTemplate>
			<template v-slot:payout-name>
				{{ selectedPayoutName }}
			</template>

			<template v-slot:payout-denomination-details>
				<PayoutSummaryCard @processPayoutClicked="processPayout"></PayoutSummaryCard>
			</template>

			<template v-slot:payout-denominations>
				<PayoutDenominations></PayoutDenominations>
			</template>


			<template v-slot:disclaimer>
				{{ selectedPayoutOption?.option?.disclaimer }}
			</template>
		</PayoutOptionDenominationsTemplate>




		<PayoutWithdrawlSuccessfull></PayoutWithdrawlSuccessfull>
		<PayoutWithdrawalFailed></PayoutWithdrawalFailed>



	</div>
</template>



<script setup>

import { computed } from "vue";
import { useRoute } from "vue-router";

import { PayoutStore } from "@/store/PayoutStore";

import PayoutWithdrawalFailed from "./Payout-Withdrawal-Failed.vue";
import PayoutDenominations from "../Common/Payout-Denominations.vue";
import PayoutWithdrawlSuccessfull from "./Payout-Withdrawal-Successfull.vue";
import PayoutSummaryCard from "@/components/Rewards/Common/Payout-Summary-Card.vue";
import PayoutOptionDenominationsTemplate from "../Common/Payout-Option-Denominations-Template.vue";

const route = useRoute();
const payoutStore = PayoutStore();
const payoutId = computed(() => parseInt(route.params.id));

const payoutOptions = computed(() => {
	return payoutStore.PayoutOptionsAndTheirDenominations;
});

const processPayout = () => {
	payoutStore.initiatePayout();
}

const selectedPayoutOption = computed(() => {
	if (payoutStore.SelectedPayoutOption?.option?.id) {
		return payoutStore.SelectedPayoutOption;
	}

	const foundOption = payoutOptions.value.find(
		(option) => option.option.id === payoutId.value
	);

	payoutStore.setSelectedPayoutOption(payoutId.value);
	return foundOption;
});

const selectedPayoutName = computed(() => {
	return selectedPayoutOption?.value?.option?.name;
});

</script>
